import React from 'react';

import { HStack, Skeleton } from '@rbilabs/universal-components';

import { AuthenticatedContainer } from './styled';

export const LoyaltyBannerSkeleton = () => {
  return (
    <AuthenticatedContainer hasPromoMessage={false}>
      <HStack justifyContent="space-between">
        <Skeleton h="$12" w="$24" rounded="md" lineHeight={50} />
        <Skeleton
          h="$9"
          w="$24"
          rounded="full"
          startColor="token.background-skeleton-loader-cta-start"
          endColor="token.background-skeleton-loader-cta-end"
          alignSelf="center"
        />
      </HStack>
      <Skeleton h={'$10'} rounded="full" mt="$5" />
    </AuthenticatedContainer>
  );
};
